import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { useNavigate } from 'react-router-dom';
import { login } from '../../reducetool/features/authSlice';
import { showError, showSuccess } from '../../utils/alertService';
import { toast } from 'react-toastify';
import { setOpenIpoModal } from '../../reducetool/features/uiSlice';
import tr from 'date-fns/esm/locale/tr/index.js';
import { registerFCMToken } from '../Firebase/fcmService';


export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Call after login is complete
  const isAuth = useSelector((state) => state.authState.isAuth);
  const [isLoading, setIsLoading] = useState(false)
  const [errMsg, setErrMsg] = useState('');
  const [loginData, setLoginData] = useState({
    auth_type: 'profile_type',
    user_mobile: '',
    user_pass: '',
  });

  const onChangeHandle = (e) => {
    const { name, value } = e.target;
    setLoginData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const AddLoginMaster = async () => {
    try {
      let config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };


      setIsLoading(true);
      let response = await apiService.post(
        'api/admin/User_Detail/Login',
        loginData,
        config
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        const { token_data, token_id } = response.authToken;
        const user = response.user;

        dispatch(
          login({
            token: token_data,
            token_id: token_id,
            user: user,
            isAuth: response.status,
          })
        );
        
        dispatch(setOpenIpoModal(true));
        // console.log(vendors, "vendorsvendorsvendorsvendors")

        toast.success('Login successful');
        // alert('Login successful');
        dispatch(setOpenIpoModal(true));
        navigate('/starter');

      } else {
        toast.error(response.message || response.errorMessage);
        //showSuccess(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <div className='login-header box-shadow'>
        <div className='container-fluid d-flex justify-content-between align-items-center'>
          <div className='brand-logo'>
            <a href='login.html'>
              <img src='vendors/images/shivkms-admin.svg' alt='' />
            </a>
          </div>
          {/* <div className="login-menu">
        <ul>
          <li>
            <a href="register.html">Register</a>
          </li>
        </ul>
      </div> */}
        </div>
      </div>
      <div className='login-wrap d-flex align-items-center flex-wrap justify-content-center'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-6 col-lg-7'>
              <img src='vendors/images/login-page-img.png' alt='' />
            </div>
            <div className='col-md-6 col-lg-5'>
              <div className='login-box bg-white box-shadow border-radius-10'>
                <div className='login-title'>
                  <h2 className='text-center text-primary'>Admin Panel - Login </h2>

                </div>

                {/* <div className="select-role">
                <div
                  className="btn-group btn-group-toggle"
                  data-toggle="buttons"
                >
                  <label className="btn active">
                    <input type="radio" name="options" id="admin" />
                    <div className="icon">
                      <img
                        src="vendors/images/briefcase.svg"
                        className="svg"
                        alt=""
                      />
                    </div>
                    <span>I'm</span>
                    Manager
                  </label>
                  <label className="btn">
                    <input type="radio" name="options" id="user" />
                    <div className="icon">
                      <img
                        src="vendors/images/person.svg"
                        className="svg"
                        alt=""
                      />
                    </div>
                    <span>I'm</span>
                    Employee
                  </label>
                </div>
              </div> */}
                <div className='input-group custom'>
                  <input
                    type='number'
                    className='form-control form-control-lg'
                    placeholder='Mobile number'
                    name='user_mobile'
                    value={loginData.user_mobile}
                    onChange={onChangeHandle}
                    autoComplete='off'
                  />
                  <div className='input-group-append custom'>
                    <span className='input-group-text'>
                      <i className='icon-copy dw dw-user1' />
                    </span>
                  </div>
                </div>
                <div className='input-group custom'>
                  <input
                    type='password'
                    className='form-control form-control-lg'
                    placeholder='**********'
                    name='user_pass'
                    value={loginData.user_pass}
                    onChange={onChangeHandle}
                  />
                  <div className='input-group-append custom'>
                    <span className='input-group-text'>
                      <i className='dw dw-padlock1' />
                    </span>
                  </div>
                </div>
                <div className='row pb-30'>
                  <div className='col-6'>
                    <div className='custom-control custom-checkbox'>
                      <input
                        type='checkbox'
                        className='custom-control-input'
                        id='customCheck1'
                      />
                      <label
                        className='custom-control-label'
                        htmlFor='customCheck1'
                      >
                        Remember
                      </label>
                    </div>
                  </div>
                  <div className='col-6'>
                    <div className='forgot-password'>
                      <a href='/forget'>Forgot Password</a>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='input-group mb-0'>
                      {/*
                      use code for form submit
                      <input class="btn btn-primary btn-lg btn-block" type="submit" value="Sign In">
                    */}
                      <button
                        className='btn btn-primary btn-lg btn-block'
                        onClick={AddLoginMaster}
                        disabled={isLoading}
                      >
                        {isLoading ? "Loading..." : <> Sign In <i className="icon-copy dw dw-logout-2"></i></>}

                      </button>
                    </div>
                    {/* <div
                      className='font-16 weight-600 pt-10 pb-10 text-center'
                      data-color='#707373'
                    >
                      OR
                    </div>
                    <div className='input-group mb-0'>
                      <a
                        className='btn btn-outline-primary btn-lg btn-block'
                        href='register.html'
                      >
                        Register To Create Account
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
